import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { fill: "currentColor" }, [
      _createElementVNode("path", {
        d: "m17.95 7.71-.14-.08-1.39-.8-2.87-1.66c-.88-.51-2.22-.51-3.1 0L7.58 6.83l-1.39.81-.18.1C4.22 8.94 4.1 9.16 4.1 11.09v4.61c0 1.93.12 2.15 1.95 3.38l4.4 2.54c.44.26.99.38 1.55.38.55 0 1.11-.12 1.55-.38l4.44-2.57c1.79-1.2 1.91-1.42 1.91-3.35v-4.61c0-1.93-.12-2.15-1.95-3.38",
        opacity: ".4"
      }),
      _createElementVNode("path", { d: "m6.19 7.64 1.39-.81 2.74-1.58.13-.08c.88-.51 2.22-.51 3.1 0l.13.08 2.74 1.58 1.39.8V5.49c0-2.25-1.24-3.49-3.49-3.49H9.67C7.42 2 6.19 3.24 6.19 5.49zm8.65 5.7-.62.76c-.1.11-.17.33-.16.48l.06.98c.04.6-.39.91-.95.69l-.91-.36a.9.9 0 0 0-.52 0l-.91.36c-.56.22-.99-.09-.95-.69l.06-.98a.75.75 0 0 0-.16-.48l-.62-.76c-.39-.46-.22-.97.36-1.12l.95-.24c.15-.04.33-.18.41-.31l.53-.82c.33-.51.85-.51 1.18 0l.53.82c.08.13.26.27.41.31l.95.24c.58.15.75.66.36 1.12" })
    ], -1)
  ]))]))
}
export default { render: render }